




















































































































































































































import { Component, Vue, Prop, Model } from 'vue-property-decorator';

import {
  IInternationalization,
  IInternationalizationStatus,
  ECountries,
  EUnavailableStatus
} from '@/models/internationalization';

import eventBus from '@/utils/eventBus';

import Arrow from '@/components/icons/Arrow.vue';
import { Typography, Picture } from '@/components/atoms';
import CountryItem, {
  BgByStatus,
  ColorByStatus
} from '@/components/molecules/CountryItem/CountryItem.vue';
import SearchIcon from '@/components/icons/Search.vue';
import CloseIcon from '@/components/icons/Close.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';
import flagKeys from '@/constants/flagKeys';
import InternationalizationService from '@/api/InternationalizationService';
import APIService from '@/api';

let timer: NodeJS.Timeout;
const DELAY = 500;

type Option = IInternationalization;

type DisclaimerInfo = {
  bg: string;
  color: string;
  text: string;
};

@Component({
  components: {
    Typography,
    Picture,
    CountryItem,
    SearchIcon,
    CloseIcon,
    Arrow,
    InputWrapper
  }
})
export default class CountrySelect extends Vue {
  @Model('input', { type: Object, default: () => ({}) }) value!: Option;

  @Prop({ default: false }) hasError?: boolean;
  @Prop({
    default: 'Select the proper country as this cannot be edited later.'
  })
  helpText?: string;
  @Prop({ default: false }) showResetHiperlink?: boolean;
  @Prop({ default: 'What country is your business located in?' })
  label?: string;
  @Prop({ default: false }) initialOpenedState?: boolean;
  @Prop({ default: true }) showDisclaimer?: boolean;

  internationalizationService = new InternationalizationService();

  isOpened = false;
  filterInput = '';
  countries: IInternationalization[] = [];
  filteredCountries: IInternationalization[] = [];

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return 'common.components.countrySelect';
  }

  get disclaimerByStatus(): Record<
    IInternationalizationStatus,
    DisclaimerInfo
  > {
    return {
      full: {
        bg: BgByStatus.FULL,
        text: '',
        color: ColorByStatus.FULL
      },
      beta: {
        bg: BgByStatus.BETA,
        text: '',
        color: ColorByStatus.BETA
      },
      online_only: {
        bg: BgByStatus.ONLINE_ONLY,
        text: String(
          this.$t(`${this.tPrefix}.onlineDisclaimer`, {
            country: this.selectedCountryName
          })
        ),
        color: ColorByStatus.ONLINE_ONLY
      },
      coming_soon: {
        bg: BgByStatus.COMING_SOON,
        text: String(this.$t(`${this.tPrefix}.comingSoonDisclaimer`)),
        color: ColorByStatus.COMING_SOON
      },
      undated: {
        bg: BgByStatus.UNDATED,
        text: String(this.$t(`${this.tPrefix}.undatedDisclaimer`)),
        color: ColorByStatus.UNDATED
      }
    };
  }

  get hasSelectedItem() {
    return !!Object.keys(this.value || {}).length;
  }

  get selectedCountryName() {
    if (!this.hasSelectedItem) return '';

    return this.value.name;
  }

  get popularCountries() {
    return Object.values(ECountries)
      .reduce(
        (prevCountries: IInternationalization[], countryName) => [
          ...prevCountries,
          this.getCountry(countryName) as IInternationalization
        ],
        []
      )
      .filter(Boolean);
  }

  get unavailableCountrySelected() {
    const unavailableStatus = Object.values(EUnavailableStatus);

    return (
      this.hasSelectedItem &&
      unavailableStatus.includes(this.value.status as EUnavailableStatus)
    );
  }

  get currentCountry() {
    return this.$store.getters['internationalization/getCurrentCountry'];
  }

  getCountry(countryName: ECountries) {
    return this.filteredCountries.find(country => country.name === countryName);
  }

  created() {
    this.getCountries();
  }

  handleToggle() {
    this.isOpened = !this.isOpened;
  }

  handleOutsideClick() {
    if (!this.isOpened) return;

    this.isOpened = false;
  }

  getCountries() {
    const sessionCountries = this.$store.getters[
      'internationalization/getCountries'
    ];

    this.countries = sessionCountries;
    this.filteredCountries = sessionCountries;
  }

  handleSearch(event: any) {
    clearTimeout(timer);

    if (!this.filterInput) {
      this.filteredCountries = this.countries;

      return;
    }

    timer = setTimeout(() => {
      const filteredCountries = this.countries.filter(country => {
        const countryName = country.name.toLowerCase();

        return countryName.includes(event.target.value.toLowerCase());
      });

      this.filteredCountries = filteredCountries;
    }, DELAY);
  }

  handleCountryClick(value: IInternationalization) {
    this.isOpened = false;
    this.$emit('input', value);
  }

  handleCountryReset() {
    this.filterInput = '';
    this.filteredCountries = this.countries;

    this.$emit('input', {});

    setTimeout(() => {
      const input = this.$refs.searchCountry as HTMLElement;

      if (input) input.focus();
    }, 0);
  }

  handleReset() {
    this.handleCountryReset();

    if (!this.$mobileCheck()) {
      this.handleToggle();
    }
  }

  useInitialOpenedState() {
    this.isOpened = this.initialOpenedState || false;
  }

  async getPreSelectedCountry() {
    let currentCountry = this.currentCountry;

    if (!currentCountry) {
      if (APIService.token) {
        const {
          data: preSelectedCountry
        } = await this.internationalizationService.getCurrentCountry();

        currentCountry = preSelectedCountry;
      } else {
        currentCountry = this.getCountry(ECountries.UnitedStates);
      }
    }

    if (currentCountry) {
      this.$emit('input', this.getCountry(currentCountry.name));
      this.isOpened = false;

      return;
    }

    this.useInitialOpenedState();
  }

  mounted() {
    eventBus.$on('resetSignupCountrySelect', this.handleCountryReset);

    if (
      !this.hasSelectedItem &&
      this.flags.includes(flagKeys.preSelectedCountry)
    ) {
      this.getPreSelectedCountry();
      return;
    }

    this.useInitialOpenedState();
  }

  beforeDestroy() {
    eventBus.$off('resetSignupCountrySelect', this.handleCountryReset);
  }
}
